import { useTheme } from '@quadminds/mindkit';
import { FC } from 'react';
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { chartColorList } from './constants';
import { groupLineDataByKey } from './utils';
import { ChartAttachment, LineChartData } from '../../pages/Chat/Chat/types';

const MindyBarChart: FC<ChartAttachment> = ({ data, options }) => {
    const { theme } = useTheme();

    if (!Array.isArray(data) || data.some((point) => Object.keys(point).length < 2)) {
        console.error('Invalid data format for BarChart. Expected an array of objects with at least two keys.');
        return null;
    }
    // the data source should have a list of objects to describe a point in the chart
    const dataGrouped = groupLineDataByKey(data as LineChartData[]);
    const axisKeys: string[] = [];

    if (options?.xKey?.key) {
        axisKeys.push(options.xKey.key);
    }
    if (options?.yKey?.key) {
        axisKeys.push(options.yKey.key);
    }

    const filteredByAxisKey = Object.fromEntries(
        Object.entries(dataGrouped).filter(([key]) => !axisKeys.includes(key)),
    );

    return (
        <div className="w-full h-[250px]">
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={data}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    {options?.xKey && options?.xKey.show && <XAxis dataKey={options?.xKey?.key} />}
                    {options?.yKey && options?.yKey.show && <YAxis dataKey={options?.yKey?.key} />}
                    <Tooltip contentStyle={theme === 'dark' ? { backgroundColor: '#202222' } : undefined} />
                    {options?.showLegend && <Legend />}
                    {Object.entries(filteredByAxisKey).map(([key, _], index) => (
                        <Bar
                            dataKey={key}
                            stackId={options?.barChartStacked ? 1 : undefined}
                            fill={chartColorList[index % chartColorList.length]}
                        />
                    ))}
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default MindyBarChart;
